import axios, { resHandle } from "@/plugins/axios";
import axios2 from 'axios';
// /**
//  * @description 获取目录式控件的选项
//  * @param vCom Vue组件
//  */
// const GetMulu = (vCom: any, loading?: any): Promise<any> => {
//     return new Promise((resolve, reject) => {
//         axios.get("api/project/mulu").then(({ data }) => {
//             resHandle(vCom, data, loading).then(() => {
//                 resolve(data.data);
//             }).catch((err) => {
//                 if (loading) {
//                     loading.close();
//                 }
//                 reject(err);
//             });
//         }).catch((err) => {
//             if (loading) {
//                 loading.close();
//             }
//             reject(err);
//         });
//     });
// };
// /**
//  * @description 术语搜素（西医疾病、中医疾病、治法治则、中医证型、中医症状）
//  * @param vCom Vue组件
//  */
// const GetTerms = (vCom: any, params: any, loading?: any): Promise<any> => {
//     return new Promise((resolve, reject) => {
//         axios.get("api/project/terms", params).then(({ data }) => {
//             resHandle(vCom, data).then(() => {
//                 resolve(data.data);
//             }).catch((err) => {
//                 if (loading) {
//                     loading.close();
//                 }
//                 reject(err);
//             });
//         }).catch((err) => {
//             if (loading) {
//                 loading.close();
//             }
//             reject(err);
//         });
//     });
// };
/**
 * @description 获取目录式控件的选项
 * @param vCom Vue组件
 */
const GetMulu = (vCom: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios2.get("https://saas.i-tcm.cn/api/project/mulu").then(({ data }) => {
            if (loading) {
                loading.close();
            }
            resolve(data.data);
        }).catch((err) => {
            if (loading) {
                loading.close();
            }
            reject(err);
        });
    });
};
/**
 * @description 术语搜素（西医疾病、中医疾病、治法治则、中医证型、中医症状）
 * @param vCom Vue组件
 */
const GetTerms = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios2.get("https://saas.i-tcm.cn/api/project/terms", params).then(({ data }) => {
            if (loading) {
                loading.close();
            }
            resolve(data.data);
        }).catch((err) => {
            if (loading) {
                loading.close();
            }
            reject(err);
        });
    });
};
/**
 * @description 获取量表疾病选项
 */
const PostJibing = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/jws_diseases", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 上传文件
 */
const UploadFile = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/system/file/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 上传图片
 * @param vCom Vue组件
 */
const UploadImage = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/upload/image", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                if (loading) {
                    loading.close();
                }
                reject(err);
            });
        }).catch(() => {
            if (loading) {
                loading.close();
            }
            reject();
        });
    });
};
/**
 * @description 上传视频
 * @param vCom Vue组件
 */
const UploadVideo = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/upload/file", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                if (loading) {
                    loading.close();
                }
                reject(err);
            });
        }).catch((err) => {
            if (loading) {
                loading.close();
            }
            reject(err);
        });
    });
};
/**
 * @description 问题弹框
 */
const PostQuestion = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/each/question", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch((err) => {
                if (loading) {
                    loading.close();
                }
                reject(err);
            });
        }).catch((err) => {
            if (loading) {
                loading.close();
            }
            reject(err);
        });
    });
};
/**
 * @description 题目记录
 */
const PostQuestionRecords = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/question/records", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch((err) => {
                if (loading) {
                    loading.close();
                }
                reject(err);
            });
        }).catch((err) => {
            if (loading) {
                loading.close();
            }
            reject(err);
        });
    });
};
/**
 * @description 获取当前用户信息，如果传了project_id则是获取当前专病的用户信息
 * @param vCom Vue组件
 */
const GetCurrentUserData = (vCom: any, params?: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/user", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            }).catch((err) => {
                if (loading) {
                    loading.close();
                }
                reject(err);
            });
        }).catch(() => {
            if (loading) {
                loading.close();
            }
            reject();
        });
    });
};
/**
 * @description 查询exe拍摄的图片
 */
const GetExeImg = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/system/file/check_file_exist/", params).then(({ data }) => {
            resolve(data);
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 舌图拍摄调光
 */
const ChangeLight = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/", params).then(({ data }) => {
            resolve(data);
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取患者详情
 */
const GetPatientDetail = (vCom: any, path: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/ceping/patient/" + path + '/').then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取每种测评模版最新的测评数据列表量表数据(全部种类有数据的只会有一个)
 * https://app.apifox.com/project/3858755/apis/api-164357479
 * @param patient_id
 * @param related_type  需要查询的计划的关联类型列表，英文逗号隔开,如"健康测评,健康设备"
 */
const GetNewsTems = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/ceping/content/get_newest_content_list/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取template列表
 */
const GetTemList = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/crf/template/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取content详情
 * https://app.apifox.com/project/3858755/apis/api-157305049
 * @param patient 患者
 * @param template{}量表模版
 * @param data 量表数据
 * 
 */
const GetContentDetail = (vCom: any, id: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/ceping/content/" + id + '/').then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 通过主诉获取症状选项
 */
const GetZhengzhuang = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/henan_sizhen/henan_sizhen_disease/inquiry_question_to_disease_diagnosis/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 根据第二步获取推荐症状选项，获得中医疾病，处方，中草药的ai推荐值
 */
const GetTuijianOptions = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/henan_sizhen/henan_sizhen_tcm_data/list_all/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 发送已选的症状体征，ai推荐中医证型
 */
const GetTuijianzhengxings = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/henan_sizhen/henan_sizhen_syndrome/diseases_and_symptoms_to_syndrome/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 搜索获取全部中草药
 */
const GetHerbs = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/henan_sizhen/henan_sizhen_herb/list_all/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 新增content
 * https://app.apifox.com/project/3858755/apis/api-157305043
 * @param patient 患者
 * @param template{} 量表信息
 * @param data []填写的数据
 * @param collect_time 采集时间
 * 
 */
const PostCepingContent = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/ceping/content/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 修改content
 * https://app.apifox.com/project/3858755/apis/api-157305051
 * @param id path参数
 * @param patient 患者
 * @param template{}量表模版
 * @param data 量表数据
 */
const EditContent = (vCom: any, id: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.patch("api/ceping/content/" + id + '/', params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description AI体质分析AI体质分析
 * @param patient 患者
 */
const PostAiTizhi = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("/api/yunnan_sizhen/yunnan_sizhen/ai_tizhi/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 分析舌
 */
const AnalyzeTongue = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/crf/shemianmai/shexiang/", params).then(({ data }) => {
            resolve(data);
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 分析面
 */
const AnalyzeFace = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/crf/shemianmai/mianxiang/", params).then(({ data }) => {
            resolve(data);
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 根据舌象初步分析中医体质类型
 */
const GetTizhiOptions = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/crf/ai_tizhi/first_analysis/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description AI体质评分接口
 */
const GetTizhiScore = (vCom: any, params: any, loading?: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/crf/ai_tizhi/score/", params).then(({ data }) => {
            resHandle(vCom, data, loading).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
export {
    PostJibing, UploadFile, GetTerms, UploadImage, UploadVideo, GetMulu,
    PostQuestion, PostQuestionRecords, GetCurrentUserData, GetExeImg,
    ChangeLight, GetPatientDetail, GetNewsTems, GetTemList, GetContentDetail,
    GetZhengzhuang, GetTuijianOptions, GetTuijianzhengxings, GetHerbs,
    PostCepingContent, EditContent, PostAiTizhi, AnalyzeTongue, AnalyzeFace,
    GetTizhiOptions, GetTizhiScore
}

